<template>
  <div
    id="end_screen"
    class="bg_screen"
  >
    <div class="congratulations-box">
      <p :style="styling">
        <template v-if="isEarly">
          <span
            v-if="!isLeaderboardUser"
            v-html="$t('congratulations_early_1', { name })"
          />
          <span v-if="isLeaderboardUser">
            <span
              v-if="typeOfUser == 'good'"
              v-html="$t('congratulations_early_leader_good', { name })"
            />
            <span
              v-if="typeOfUser == 'bad'"
              v-html="$t('congratulations_early_leader_bad', { name })"
            />
            <span
              v-if="typeOfUser == 'neutral'"
              v-html="$t('congratulations_early_leader_neutral', { name })"
            />
          </span>

          <span
            v-if="!isPiraeus && !isLeaderboardUser"
            v-html="$t('congratulations_early_2')"
          />
        </template>
        <span
          v-else-if="hasNoMoreAvailableThisMonth"
          v-html="$t('congratulations_no_more_this_month')"
        />
        <span v-else-if="isLeaderboardUser">
          <span
            v-if="typeOfUser == 'good'"
            v-html="$t('congratulations_early_leader_good', { name })"
          />
          <span
            v-if="typeOfUser == 'bad'"
            v-html="$t('congratulations_early_leader_bad', { name })"
          />
          <span
            v-if="typeOfUser == 'neutral'"
            v-html="$t('congratulations_early_leader_neutral', { name })"
          />
        </span>
        <span
          v-else
          v-html="$t('congratulations', { name })"
        />

        <br>

        <template v-if="isEarly && !isPiraeus && !isLeaderboardUser">
          <a :href="dashboardGameScreen">
            {{ $t("show_results") }}
          </a>
          &nbsp;|&nbsp;
          <a @click="continueOptionalSkills">
            {{ $t("continue_optional_skills") }}
          </a>
        </template>
        <a
          v-else-if="!isPiraeus && !isLeaderboardUser"
          :href="dashboardGameScreen"
        >
          {{ $t("show_results") }}
        </a>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EndScreen',
  computed: {
    dashboardGameScreen() {
      if (this.isDUTH) {
        return 'https://duth.owiwi.co.uk/play'
      }
      return process.env.VUE_APP_DASHBOARD_GAME_SCREEN
    },

    isEarly() {
      if (Object.keys(this.$route.query).length) {
        return this.$route.query.finishEarly
      }
      return false
    },

    hasNoMoreAvailableThisMonth() {
      if (Object.keys(this.$route.query).length) {
        return this.$route.query.noMoreAvailableThisMonth
      }
      return false
    },

    name() {
      return this.$store.getters.name
    },

    isPiraeus() {
      return this.$store.getters.isPiraeus
    },

    isDUTH() {
      return this.$store.getters.isDUTH
    },

    leaderboardUsers() {
      return this.$store.getters.leaderboardUsers
    },

    typeOfUser() {
      if (this.leaderboardUsers.good.includes(this.userEmail)) {
        return 'good'
      }

      if (this.leaderboardUsers.bad.includes(this.userEmail)) {
        return 'bad'
      }

      if (this.leaderboardUsers.neutral.includes(this.userEmail)) {
        return 'neutral'
      }

      return null
    },

    userEmail() {
      return this.$store.getters.email
    },

    isLeaderboardUser() {
      return (
        this.leaderboardUsers.good.includes(this.userEmail) ||
        this.leaderboardUsers.bad.includes(this.userEmail) ||
        this.leaderboardUsers.neutral.includes(this.userEmail)
      )
    },

    styling() {
      if (this.isEarly || this.hasNoMoreAvailableThisMonth) {
        return this.$i18n.locale === 'el' ? 'font-size: 0.7em' : 'font-size: 0.75em'
      }

      return ''
    }
  },

  methods: {
    continueOptionalSkills() {
      window.location.reload()
    }
  },

  created() {
    this.$parent.$refs.header.allowMuteNarration = false
    this.$parent.$refs.header.allowFontEdit = false

    this.resetNarrationSound()
  }
}
</script>
